import CellButton from "../components/cells/CellButton";
import CellButtonWithActionIcons from "../components/cells/CellButtonWithActionIcons";
import CellButtonWithIcon from "../components/cells/CellButtonWithIcon";
import CellChipArray from "../components/cells/CellChipArray";
import CellChipStatus from "../components/cells/CellChipStatus";
import CellCountWithIcon from "../components/cells/CellCountWithIcon";
import CellDate from "../components/cells/CellDate";
import CellImage from "../components/cells/CellImage";
import CellInfoTooltip from "../components/cells/CellInfoTooltip";
import CellNumber from "../components/cells/CellNumber";
import CellPopoverInfo from "../components/cells/CellPopoverInfo";
import CellRate from "../components/cells/CellRate";
import CellText from "../components/cells/CellText";
import CellTime from "../components/cells/CellTime";
import CellTextWithCopy from "../components/cells/CellTextWithCopy";

export const getRenderComponent = (type: string | null = null) => {
  const map = {
    BUTTON: CellButton,
    STATUS: CellChipStatus,
    CHIP_ARRAY: CellChipArray,
    TEXT: CellText,
    TEXT_WITH_COPY: CellTextWithCopy,
    INFO_TOOLTIP: CellInfoTooltip,
    POPOVER_INFO: CellPopoverInfo,
    NUMBER: CellNumber,
    DEFAULT: CellText,
    DATE: CellDate,
    TIME: CellTime,
    COUNT_WITH_ICON: CellCountWithIcon,
    BUTTON_WITH_ICON: CellButtonWithIcon,
    BUTTON_WITH_ACTION_ICONS: CellButtonWithActionIcons,
    RATE: CellRate,
    IMAGE: CellImage,
  };

  if(!type) return CellText;

  return map[type] || null;
};
